import axiosInstance from "../../../helpers/api";

export const createVideoVouchers = () => {
  return axiosInstance.post("/superadmin/video-vouchers/bulk");
};

export const getAllVideos = (body) => {
  return axiosInstance.get("/superadmin/videos", body);
};

export const getPaymentSubjects = (body) => {
  return axiosInstance.get("/admin/payment_subject", body);
};

export const editVideos = (formData) => {
  return axiosInstance.put(
    `/superadmin/videos/${formData.id}`,
    formData.formData
  );
};

export const suspendVideos = (formData) => {
  return axiosInstance.post(
    `/superadmin/videos/suspend/${formData.id}`,
    formData.formData
  );
};

export const createVideo = (formData) => {
  return axiosInstance.post("/superadmin/videos", formData);
};

export const deleteVideo = (id) => {
  return axiosInstance.delete(`/superadmin/videos/${id}`);
};

export const getCourseVideos = (id) => {
  return axiosInstance.get(`/superadmin/videos/course/${id}`);
};

export const deleteVideoFile = (id) => {
  return axiosInstance.delete(`/admin/video_files/${id}`);
};

export const addVideoFiles = (formData) => {
  return axiosInstance.post(`/admin/video_files`, formData);
};
